export default {
      id: "icon-page-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-page",
      toString: function () {
        return this.url;
      }
    }